"use client";

import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

interface ScrollIndicatorProps {
  className?: string;
}

export default function ScrollIndicator({ className = "" }: ScrollIndicatorProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: [0, 8, 0] }}
      transition={{ duration: 1.2, ease: "easeInOut", repeat: Number.POSITIVE_INFINITY }}
      className={`flex flex-col items-center gap-2 ${className}`.trim()}
    >
      <span className="text-[11px] uppercase tracking-[0.35em] text-text-muted/90">Kerri alla</span>
      <div className="rounded-full border border-accent/40 p-2">
        <ArrowDown className="h-4 w-4 text-accent" />
      </div>
    </motion.div>
  );
}
